<template lang="pug">
.form-check.dawn-checkbox
  label.form-check-label
    input.form-check-input(
      :id='optionLabel'
      :name='name'
      type='checkbox'
      :checked='optionStatus'
      :value='optionStatus'
      v-bind='$props'
      @click='changeStatus'
    )
    | {{ optionLabel }}
</template>

<script>

import { EventBus } from '@/event-bus'

export default {
  name: 'checkbox',
  props: {
    optionIndex: Number,
    optionLabel: String,
    optionStatus: Boolean,
    name: String,
    disabled: Boolean
  },
  computed: {
    _optionStatus: function() {
      return this.optionStatus
    },
    _optionLabel: function() {
      return this.optionName
    },
    _optionIndex: function() {
      return this.optionIndex
    }
  },
  methods: {
    changeStatus: function(e) {
      EventBus.$emit('changeStatus', {
        'idx': this._optionIndex,
        'status': !this._optionStatus,
        'value': e.target.checked
      })
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.theme.skin .form-group .form-check-label,
.form-check-label {
  padding-left: 0;
  margin-bottom: 0;
  font-weight: $font-weight-normal;
  font-size: $font-size-xsmall;
  color: $primary-04;
  cursor: pointer;
}

.dawn-checkbox {
  input[type=checkbox] {
    @include form-field;
    @include dawn-checkbox;
  }
}

</style>



// WEBPACK FOOTER //
// checkbox.vue?026b4b11